<template>
<div>
  <div class="container" v-if="notAnswered">
    <p class="question">{{ questionObject.question }}</p>
    <div class="row text-center px-lg-3 mt-4">
      <div class="col-xs-12 col-md-6 col-lg-4 mt-1 p-0 options-row" v-for="answerObject in questionObject.answers" :key="answerObject.id">
        <div @click="answerQuestion(answerObject)">
          <img class="options-item" :src="answerObject.answer" height="250"  />
        </div>
      </div>
    </div>
  </div>
  <transition name="component-fade" mode="out-in">
    <ResponseMaster :response="response" @next="nextQuestion" v-if="!notAnswered"/>
  </transition>
</div>
</template>

<script>

import ResponseMaster from './ResponseMaster'
  
export default {
  name: 'ImageQuest',
  components: {
    ResponseMaster
  },
  props: {
    questionObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return { 
      notAnswered: true,
      response: "",
      points: 0
    }
  },
  methods: {
    answerQuestion(answer) {
      this.response    = answer.response
      this.points      = answer.points
      this.notAnswered = false
    },
    nextQuestion() {
      this.notAnswered = true
      this.$emit('answer', this.points)
    }
  }
}
</script>
<style scoped>
  .question {
    color: #000;
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 50px;
  }
  .options-row {
    margin: 30px auto;
  }
  .options-item {
    max-width: 300px;
  }

  .options-row:hover {
    transition: .5s ease;
    background-color: #000;
    cursor: pointer;
    border-radius: 10px;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .5s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
  }
</style>